export default function() {
    return {
        transactions: [],
    };
}
